export default "__VITE_ASSET__ff6ab317__"